// The mark and the wordmark (docs/UI-POLISH.md decision 8): an "H" built from three hue bands of the teal accent on a
// dark tile; the same drawing is `public/favicon.svg`. Easy to replace when a real logo exists.
export function Mark({ size = 28, title }: { size?: number; title?: string }) {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" role={title ? 'img' : undefined} aria-hidden={title ? undefined : true} aria-label={title}>
      {title && <title>{title}</title>}
      <rect width="32" height="32" rx="8" fill="#0d1b1f" />
      <rect x="7" y="7" width="5" height="18" rx="1.5" fill="#2fd3bd" />
      <rect x="20" y="7" width="5" height="18" rx="1.5" fill="#43c0e6" />
      <rect x="7" y="13.5" width="18" height="5" rx="1.5" fill="#9af0e3" />
    </svg>
  );
}

export function Wordmark({ className = '' }: { className?: string }) {
  return <span className={`wordmark ${className}`}>Huelency</span>;
}

export function Brand({ size = 28 }: { size?: number }) {
  return (
    <span className="row" style={{ gap: 10 }}>
      <Mark size={size} />
      <Wordmark />
    </span>
  );
}
